import Label from "./Label";
import FieldError from "./FieldError";
import TextField from "./TextField";
import FormFieldWrapper from "./FormFieldWrapper";
import type { InputProps } from "./InputProps";

export default function Input({
  required = true,
  defaultValue = undefined,
  list,
  label,
  id,
  type = "text",
  autocomplete = "off",
  onFocus,
  value = undefined,
  placeholder,
  error,
  pattern,
  disabled,
  tabIndex = undefined,
  onChange,
  onBlur,
  readOnly,
  onClick,
  onIconClick,
  iconName,
  appendElement,
  onKeyDown,
  step,
  iconTabIndex,
}: InputProps) {
  return (
    <FormFieldWrapper>
      <Label id={id} required={required} label={label} disabled={disabled} />
      <TextField
        onKeyDown={onKeyDown}
        id={id}
        type={type}
        defaultValue={defaultValue}
        required={required}
        autocomplete={autocomplete}
        value={value}
        list={list}
        pattern={pattern}
        placeholder={placeholder}
        disabled={disabled}
        tabIndex={tabIndex}
        onChange={onChange}
        onBlur={onBlur}
        onClick={onClick}
        onIconClick={onIconClick}
        readOnly={readOnly}
        iconName={iconName}
        iconTabIndex={iconTabIndex}
        appendElement={appendElement}
        error={error}
        onFocus={onFocus}
        step={step}
      />
      <FieldError error={error} />
    </FormFieldWrapper>
  );
}
